import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer>
      <div class="container border-top">
        <div class="nav-footar py-3">
          <ul class="nav flex-row ">
            <li className="nav-item">
              <Link className="nav-link text-muted " aria-current="page" to="/">
                الصفحة الرئيسة
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-muted" to="#">
                الخدمات
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-muted" to="#">
                من نحن
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-muted " to="#">
                تواصل معنا
              </Link>
            </li>
          </ul>
        </div>

        <div class="d-flex flex-column flex-sm-row justify-content-between  border-top text-center  pt-4">
          <p> جميع الحقوق محفوظة &copy; لشركة نقل الرياض بالرياض</p>

          <ul class=" list-unstyled d-flex alighn-items-center justify-content-center">
            <li class="ms-3">
              <a class="nav-link" href="#">
                <i class="fa-brands fa-x-twitter"></i>
              </a>
            </li>
            <li class="ms-3">
              <a class="nav-link" href="#">
                <i class="fa-brands fa-instagram"></i>
              </a>
            </li>
            <li class="ms-3">
              <a class="nav-link" href="#">
                <i class="fa-brands fa-facebook"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
